import { Instagram, Linkedin } from "lucide-react";
import { Link } from "react-router-dom";
import { NAV_LINKS } from "../data/content";

const FOOTER_LINKS = NAV_LINKS.filter((l) => l.href !== "/#video");

export const Footer = () => (
  <footer className="site-footer" data-testid="site-footer">
    <div className="wrap">
      <div className="footer-top">
        <Link to="/" data-testid="footer-logo">
          <img src="/assets/brand/logo.png" alt="KR Studio" className="footer-logo" />
        </Link>
        <ul className="footer-links">
          {FOOTER_LINKS.map((l) => (
            <li key={l.href}>
              <Link to={l.href} data-testid={`footer-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}>{l.label}</Link>
            </li>
          ))}
          <li><Link to="/contact" data-testid="footer-link-contact">Contact</Link></li>
          <li><Link to="/privacy-policy" data-testid="footer-link-privacy">Privacy Policy</Link></li>
        </ul>
        <div className="social-row">
          <a href="https://www.instagram.com/the.krstudio/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" data-testid="footer-instagram">
            <Instagram size={18} />
          </a>
          <a href="https://www.linkedin.com/company/kr-studio-india/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" data-testid="footer-linkedin">
            <Linkedin size={18} />
          </a>
        </div>
      </div>
      <div className="footer-bottom">
        <span data-testid="footer-copyright">© 2026 KR Studio. All rights reserved.</span>
        <span data-testid="footer-contact-line">Delhi NCR, India · ask.kr.studio@gmail.com · +91 70066 76788</span>
      </div>
    </div>
  </footer>
);
